import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const INFO_GROUP_CONSTANTS = {
  ADD_PAGE_TITLE: "Agregar grupo de información",
  PAGE_EDIT_TITLE: "Edición de grupo de información",
  PAGE_TITLE: "Grupos de información",
  PAGE_GROUP_TITLE_SEARCH: "Consulta grupos de información",
  INFO_GROUP_ROUTE: "/info-group",
  INFO_GROUP_BASIC_NAME: "Información Básica",
  INFO_GROUP_BASIC_ID: "mFiJzha3hVn1t5XYXLmB",
  INFO_GROUP_STATE_TITLE: "Estados",
  ADD_LIST: "Crear Lista",
  BUTTON: {
    ADD_INFO_GROUP_TEXT: "Crear grupo de información",
    ADD_FIELD_BTN_TEXT: "Campo",
    CLOSE: "Cerrar"
  },
  LABEL: {
    INFO_GROUP_NAME: "Nombre*",
    INFO_GROUP_DESC: "Descripción",
    DESCRIPTION: "Descripción:",
    STATE: "Estado:",
    DATE_CREATED: "Fecha de creación:",
    DATE_CHANGED: "Fecha de modificación:"
  },
  PLACEHOLDER: {
    INFO_GROUP_NAME: "Antecedentes clínicos",
    INFO_GROUP_DESC: "Acerca de los pacientes"
  },
  DIALOG_MESSAGE: {
    INFO_GROUP_NAME_EXIST: "Ya existe un grupo con ese nombre",
    ERROR: "Ocurrió un error, intente más tarde",
    DELETE_GROUP_BASIC_INFO:
      "No se puede eliminar el grupo de información básica",
    ERROR_DELETE_ID_NOT_FOUND: "El grupo de información a eliminar no existe",
    ERROR_EDIT_ID_NOT_FOUND: "El grupo de información a editar no existe",
    ERROR_SAVE_INFO_GROUP: "Ocurrió un error al guardar",
    INFO_GROUP_USED:
      "El grupo de información no se puede eliminar porque está en uso",
    INFO_GROUP_DELETED: "Grupo de información eliminado correctamente"
  },
  EMPTY_STATE: {
    EMPTY_STATE_HEADER: "No se pudo cargar la gráfica",
    EMPTY_STATE_PARAGRAPH:
      "Hubo un error al cargar la gráfica, intente refrescando la página"
  },
  INFO_GROUP_REASON_MODAL: {
    TITLE: "Eliminar grupo de información",
    MESSAGE:
      "Ingrese la razón por la cual va a deshabilitar el grupo de información: "
  },
  PREFERRED_COUNTRIES: ["CO"]
};

export const INFO_GROUP_MAIN_FILTER = {
  mainFilterKey: "all",
  mainFilterName: "Todos",
  avatar: "mdi-animation",
  secondaryFilters: [],
  initial: true,
  placeholder:
    "Escriba el nombre de la lista o utiliza los filtros para agrupar información"
};

export const INFO_GROUP_SECONDARY_FILTERS: {
  [key: string]: SecondaryFilter;
} = {
  NAME: {
    name: "Nombre",
    placeholder: "Nombre de Grupo de informacion",
    key: "name",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    default: true,
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.UNIQUE
  },
  STATUS: {
    name: "Estado",
    placeholder: "Estado de Grupo de informacion",
    key: "status",
    avatar: "mdi-list-status",
    type: "secondaryFilter",
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      { name: "Activo", key: "Activo" },
      { name: "Inactivo", key: "Inactivo" }
    ]
  }
};

export const USER_TEMPLATE_SECONDARY_FILTERS: {
  [key: string]: SecondaryFilter;
} = {
  NAME: {
    name: "Nombre",
    placeholder: "Nombre de Plantilla de Usuario",
    key: "name",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    default: true,
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.UNIQUE
  },
  STATUS: {
    name: "Estado",
    placeholder: "Estado de Plantilla de Usuario",
    key: "status",
    avatar: "mdi-list-status",
    type: "secondaryFilter",
    disabled: false,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      { name: "Activo", key: "Activo" },
      { name: "Inactivo", key: "Inactivo" }
    ]
  }
};

export const TYPE_BASE_KEY = {
  MAXIMUM: "maximum"
};

export const TYPE_BASE = {
  STRING: { DATA: { label: "String", value: "string" } },
  NUMBER: {
    DATA: { label: "Numérico", value: "number" },
    DEFAULT: { MAXIMUM: 99999999999999 }
  },
  INTEGER: {
    DATA: { label: "Numérico", value: "integer" },
    DEFAULT: { MAXIMUM: 99999999999999 }
  },
  DATE: { DATA: { label: "Fecha", value: "date" } },
  ARRAY: { DATA: { label: "Arreglo", value: "array" } },
  BOOLEAN: { DATA: { label: "Booleano", value: "boolean" } },
  OBJECT: { DATA: { label: "Objeto", value: "object" } },
  FIELD_TYPE: {
    BASICO: { label: "Campo básico", value: "basico" },
    LISTA: { label: "Lista", value: "lista" },
    TELEFONO: { label: "Teléfono", value: "telefono" }
  }
};

export const FIELD_GROUP_CONSTANTS = {
  ADD_FIELD_TITLE: "Agregar campo*",
  EDIT_FIELD_TITLE: "Editar campo",
  ADD_ELEMENT_EMMIT: "addElement",
  LABEL: {
    URL_ICON: "Icono",
    HELP_TEXT: "Texto de ayuda",
    TITLE: "Título*",
    CONVERSATION_TITLE: "Título conversacional",
    VISIBLE: "Visible",
    EDITABLE: "Editable",
    REQUIRED: "Requerido",
    VISUAL_ELEM: "Elemento visual*",
    MIN_VALUE: "Valor mínimo*",
    MAX_VALUE: "Valor máximo*",
    STEP: "Valor del paso",
    ADD_VALUES: "Agregue los valores",
    FIELD_TYPE: "Tipo de campo*",
    DATA_TYPE: "Tipo de dato*",
    HINT: "Para agregar un nuevo valor presione enter",
    SEARCH_LIST: "Búsqueda de lista",
    ADD_LIST: "Elección de lista*",
    HINT_SEARCH_LIST: "Seleccione una lista",
    HINT_LIST: "Escriba el nombre de la lista y presiona enter para buscar"
  },
  MESSAGE: {
    MAX_LENGTH: "Máximo 300 caracteres",
    MIN_FIELDS: "Debe agregar al menos un campo."
  },
  FIELD_TYPE: {
    LIST: "lista",
    PHONE: "telefono",
    STRING: "string",
    NUMBER: "number",
    INTEGER: "integer",
    SLIDER: "slider",
    CHECKBOX: "checkbox",
    RADIO: "radio",
    SWITCH: "switch",
    SELECT: "select",
    INPUT: "input",
    AUTOCOMPLETE: "autocomplete",
    EMAIL: "email",
    TEXTAREA: "textarea"
  },
  FIELD_FORMAT: {
    DATE: "date"
  }
};

export const FIELD_TYPE = [
  { label: "Campo básico", value: "basico" },
  { label: "Lista", value: "lista" },
  { label: "Teléfono", value: "telefono" }
];

export const VISUAL_ELEMENT_TYPE = {
  basico: [
    { label: "Input", value: "string" },
    { label: "Radio", value: "radio" },
    { label: "Checklist", value: "checkbox" },
    { label: "Slider", value: "slider" },
    { label: "Toggle", value: "switch" }
  ],
  lista: [
    { label: "Select", value: "select" },
    { label: "Radio", value: "radio" },
    { label: "Checklist", value: "checkbox" }
  ],
  telefono: [{ label: "Teléfono", value: "phone" }]
};

export const DATA_TYPE_SIMPLE = {
  radio: TYPE_BASE.STRING.DATA.value,
  checkbox: TYPE_BASE.ARRAY.DATA.value,
  select: TYPE_BASE.STRING.DATA.value,
  slider: TYPE_BASE.INTEGER.DATA.value,
  switch: TYPE_BASE.BOOLEAN.DATA.value,
  phone: TYPE_BASE.OBJECT.DATA.value
};

export const DATA_TYPE = {
  string: [TYPE_BASE.STRING.DATA, TYPE_BASE.INTEGER.DATA, TYPE_BASE.DATE.DATA],
  radio: [TYPE_BASE.STRING.DATA],
  checkbox: [TYPE_BASE.ARRAY.DATA],
  select: [TYPE_BASE.STRING.DATA],
  slider: [TYPE_BASE.INTEGER.DATA],
  switch: [TYPE_BASE.BOOLEAN.DATA],
  stringOnly: [TYPE_BASE.STRING.DATA],
  phone: [TYPE_BASE.OBJECT.DATA]
};

export const INFO_GROUP_VALIDATORS = {
  MAX_LENGTH: (v: string) => {
    if (v == "") {
      return true;
    }
    return (v && v.length <= 300) || FIELD_GROUP_CONSTANTS.MESSAGE.MAX_LENGTH;
  }
};

export const INFO_GROUP_EVENTS = {
  CLOSE_MODAL_FIELD_GROUP: "modalFieldGroupCancel",
  CLOSE_MODAL_PREVIEW: "modalPreviewClose",
  REFRESH_DATA: "refreshData",
  CREATE_LIST: "createList"
};

export const INFO_CHART_NAMES = {
  STATES: "Estado"
};

export const BUTTON_ACTION = {
  TOGGLE_INFO_GROUP: "toggleInfoGroup"
};

export const SAVE_INFO_GROUP_ID = "infoGroupForm";

export const INFO_GROUP_STATE = {
  ACTIVE: "Activo",
  INACTIVE: "Inactivo",
  NA: "N/A"
};

export const OPTIONS_PANEL = [
  {
    value: "createList",
    srcImg: "search-options.png",
    name: "Crear Lista"
  }
];

export const INFO_GROUPS_ACCESS = {
  GET: "consultar grupos de información",
  POST: "crear grupos de información",
  PUT: "modificar grupos de información",
  DELETE: "eliminar grupos de información"
};
